export const handleKeyDown = (e, callback) => {
	if (e.key === "Enter" || e.key === " ") {
		callback();
	}
};
